export default __webpack_public_path__ + "static/media/drello2.1f516ece.gif";